if (!customElements.get('vf-order-tracking')) {
  customElements.define('vf-order-tracking', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('[name="orderNumber"]');
      this.error = this.querySelector('[role="alert"]');
      this.status = this.querySelector('[role="status"]');
      this.awbForm = this.querySelector('.vf-awb-form');
      if (!this.form || !this.input || this.onSubmit) return;

      this.onInput = () => {
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
        if (this.status) this.status.hidden = true;
      };
      this.onSubmit = async (event) => {
        event.preventDefault();
        const reference = this.input.value.trim();
        if (!/^[#A-Za-z0-9-]{3,40}$/.test(reference)) {
          this.showError();
          return;
        }
        this.onInput();

        const lookupUrl = this.form.dataset.lookupUrl || '/apps/order-tracking';
        if (!lookupUrl) {
          this.showStatus('We could not check this order right now. Please contact us for the latest status.');
          return;
        }

        this.showStatus('Checking your order...');
        try {
          const response = await fetch(lookupUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ order_number: reference }),
            credentials: 'same-origin'
          });
          const result = await response.json();
          if (!response.ok) {
            this.showStatus(result.message || 'We could not check this order right now. Please contact us for the latest status.');
            return;
          }
          const status = String(result.status || '').toLowerCase();

          if (status === 'unfulfilled' || status === 'not_shipped' || status === 'confirmed' || status === 'processing') {
            this.showStatus(result.message || 'Your order has to be shipped from our warehouse. Tracking will appear once it is handed to Delhivery.');
            return;
          }

          const awb = result.awb || result.tracking_number || result.waybill;
          const trackingUrl = result.tracking_url || (awb ? this.buildDelhiveryUrl(awb, this.form.dataset.trackingBase) : '');
          if ((status === 'shipped' || status === 'fulfilled' || status === 'in_transit' || status === 'delivered') && trackingUrl) {
            this.openTrackingUrl(trackingUrl);
            return;
          }

          this.showStatus(result.message || 'We could not find tracking for this order yet. Please try again later or contact us.');
        } catch {
          this.showStatus('We could not check this order right now. Please try again later or contact us with your order number.');
        }
      };
      this.onAwbSubmit = (event) => {
        event.preventDefault();
        const input = this.awbForm?.querySelector('[name="uniqueIdentifier"]');
        const reference = input?.value.trim() || '';
        if (!/^(?:\d{8,20}|[A-Za-z]{2}\d{9}[A-Za-z]{2})$/.test(reference)) {
          input?.focus();
          return;
        }
        this.openTrackingUrl(this.buildDelhiveryUrl(reference, this.awbForm.dataset.trackingBase));
      };
      this.form.addEventListener('submit', this.onSubmit);
      this.input.addEventListener('input', this.onInput);
      this.awbForm?.addEventListener('submit', this.onAwbSubmit);
    }

    showError(field = this.input) {
      this.error.hidden = false;
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }

    showStatus(message) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.hidden = false;
    }

    showTrackingLink(url) {
      if (!this.status) return;
      this.status.textContent = '';
      const message = document.createElement('span');
      message.textContent = 'Tracking is ready. ';
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'Open Delhivery tracking in a new window';
      this.status.append(message, link);
      this.status.hidden = false;
    }

    openTrackingUrl(url) {
      const trackingWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (!trackingWindow) {
        this.showTrackingLink(url);
        return;
      }
      this.showStatus('Tracking opened in a new window.');
    }

    buildDelhiveryUrl(reference, base) {
      const fallback = 'https://www.delhivery.com/track-v2/package/{tracking_number}';
      let destination;
      try {
        destination = new URL((base || fallback).includes('{tracking_number}')
          ? (base || fallback).replaceAll('{tracking_number}', encodeURIComponent(reference))
          : `${base}${encodeURIComponent(reference)}`);
        if (destination.protocol !== 'https:' ||
            !(destination.hostname === 'delhivery.com' || destination.hostname.endsWith('.delhivery.com'))) {
          throw new Error('Invalid tracking destination');
        }
      } catch {
        destination = new URL(fallback.replace('{tracking_number}', encodeURIComponent(reference)));
      }
      if (/^[A-Za-z]{2}\d{9}[A-Za-z]{2}$/.test(reference)) {
        destination = new URL(`https://international-track.delhivery.com/#/trackdetail/${encodeURIComponent(reference)}`);
      }
      return destination.href;
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.input?.removeEventListener('input', this.onInput);
      this.awbForm?.removeEventListener('submit', this.onAwbSubmit);
      this.onSubmit = null;
    }
  });
}
